import api from "./api";

export const fetchStatusHistory = async (itemType = null, itemId = null) => {
  try {
    let url = "/status-history-management/";

    const params = [];
    if (itemType) params.push(`item_type=${itemType}`);
    if (itemId) params.push(`item_id=${itemId}`);

    if (params.length) {
      url += `?${params.join("&")}`;
    }

    const response = await api.get(url);

    if (response.status === 200 && response.data.success) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: response.data?.message || "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching status history:", error);
    return {
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch status history",
    };
  }
};
